/**
 * Sleep for time millis
 */
export function sleep(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * Clones things
 */
export function clone(value: any) {
  if (value === undefined || value === null || value === "") {
    return value;
  }

  return JSON.parse(JSON.stringify(value));
}

/**
 * Type safe clone
 */
export function cloneObject<T>(value: T): T {
  if (value === undefined || value === null || value === "") {
    return value;
  }

  return JSON.parse(JSON.stringify(value)) as T;
}

export function debounce(func: any, delay: number) {
  let timeoutId: NodeJS.Timeout = undefined;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func(args);
    }, delay);
  };
}

export function clamp(value: number, min: number, max: number) {
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value;
  }
}
